import React from 'react';
import { Helmet } from 'react-helmet';
import Title from '../../../../components/Title';
import { useDispatch, useSelector } from 'react-redux';
import { oneClient } from '../../../../redux/slices/clientsSlice';
import PageNavigation from './PageNavigation';
import { useEffect } from 'react';
import { getStandartTimings } from '../../../../redux/slices/communicationSlice';
import { ClientCommunicationPriority } from '../ClientNotificationsSubPage/ClientCommunicationPriority';
import { Outlet } from 'react-router-dom';

export default function UserComunicationSubPage() {
    const client = useSelector(oneClient);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getStandartTimings());
    }, [dispatch]);

    return (
        <div>
            <Helmet>
                <title>{`Console Defentry - Clients - ${client.name} - User communication`}</title>
            </Helmet>
            <Title
                subText="Creating partner specific communication"
                isSubPageTitle
            >
                User communication
            </Title>
            <ClientCommunicationPriority />
            <div className="navigation-tabs__wrapper">
                <PageNavigation />
            </div>
            <Outlet />
        </div>
    );
}
